export default {
    template: document.querySelector('[data-quiz-result-template]') ?
            document.querySelector('[data-quiz-result-template]').innerHTML:
            null,
    props: {
        questions: {
            type: Array,
        },
        score: {
            type: Object,
        },
        scores: {
            type: Array,
        }
    },
    computed: {
        /**
         * Max score
         * @return {number}
         */
        maxScore() {
            let maxScore = 0;

            this.questions.forEach(question => {
                maxScore += question.answers.find(answer => answer.isCorrect).points;
            });

            return maxScore;
        },
        /**
         *
         * @return {*}
         */
        currentScoreObject () {
            return this.scores.find(scoreObject => scoreObject.minimumScore <= this.score);
        }
    },
    created() {
        console.log(this.currentScoreObject);
    }
}